import importerSelectors from 'src/modules/shared/importer/importerSelectors';

export const unlistedCompanyImporterSelectors = importerSelectors(
  'company.unlistedImporter',
);

export const listedCompanyImporterSelectors = importerSelectors(
  'company.listedImporter',
);
